<template>
  <nav class="navbar navbar-expand-md navbar-dark bg-dark">
    <div class="container-fluid p-md-0 ps-md-1">
      <button
        v-if="!empty && $userStore.$state.user !== null"
        aria-controls="navbarToggled"
        aria-expanded="false"
        aria-label="Toggle Navigation"
        class="navbar-toggler"
        data-bs-target="#navbarToggled"
        data-bs-toggle="collapse"
        type="button"
      >
        <span class="navbar-toggler-icon" />
      </button>

      <nuxt-link class="navbar-brand" to="/">
        <svg height="34px" viewBox="0 0 90 112" x="0px" xmlns="http://www.w3.org/2000/svg" y="0px">
          <g>
            <path
              d="M72.42,43.31c-6.72-7.21-15.99-11.17-26.1-11.17h-0.7c-3.36,0-6.96,2.74-6.96,6.82
              c0,4.03,2.93,6.96,6.96,6.96c13.42,0,22.44,11.67,22.44,22.57c0,10.86-8.63,22.58-22.58,22.58c-17.17,0-27.77-8.73-35.09-16.55
              v14.48c6.54,6.79,18.07,14.87,35.93,15.01c19.81,0,35.93-16.12,35.93-35.93C82.25,59.03,78.67,50.01,72.42,43.31z"
              fill="#FFFFFF"
            />
            <path
              d="M7.75,39.93c0,9.09,3.58,18.13,9.83,24.81c6.71,7.17,15.98,11.12,26.1,11.12h0.7c3.29,0,6.96-2.8,6.96-6.82
              c0-3.97-2.99-6.96-6.96-6.96c-13.42,0-22.44-11.67-22.44-22.57c0-10.86,8.63-22.57,22.57-22.57c11.3,0,20.84,3.7,29.94,11.63V14.44
              C65.85,7.63,55.49,4.12,43.67,4C23.86,4,7.75,20.12,7.75,39.93z"
              fill="#FFFFFF"
            />
          </g>
        </svg>
      </nuxt-link>

      <div id="navbarToggled" class="collapse navbar-collapse">
        <ul v-if="user && user.Verified && !empty" class="navbar-nav me-auto mb-2 mb-md-0">
          <li
            v-if="
              role(['vendor']) ||
              (role(['buyer', 'member']) && (permission('sales') || permission('accounting')))
            "
            class="nav-item dropdown"
          >
            <a class="nav-link dropdown-toggle" data-bs-toggle="dropdown" role="button">
              {{ tr(`Reports`) }}
            </a>
            <ul class="dropdown-menu">
              <template
                v-if="
                  user.Stores.length > 0 &&
                  role(['buyer', 'member']) &&
                  permission('sales') &&
                  user.Stores[0][0] !== 1000
                "
              >
                <li>
                  <nuxt-link class="dropdown-item" to="/dashboards/member-dashboard">
                    {{ tr('Sales Dashboard') }}
                  </nuxt-link>
                </li>
                <li>
                  <nuxt-link
                    v-if="permission('customers')"
                    class="dropdown-item"
                    to="/dashboards/customer-dashboard"
                  >
                    {{ tr('Customer Dashboard') }}
                  </nuxt-link>
                </li>
                <li>
                  <nuxt-link class="dropdown-item" to="/open-to-buy">
                    {{ tr('Open To Buy') }}
                  </nuxt-link>
                </li>
              </template>

              <li
                v-if="
                  user.Stores.length > 0 && role(['buyer', 'member']) && permission('accounting')
                "
              >
                <nuxt-link class="dropdown-item" to="/fulfillment/accounting">
                  {{ tr('Website Accounting') }}
                </nuxt-link>
              </li>

              <li v-if="user.Vendors.length > 0">
                <nuxt-link class="dropdown-item" to="/dashboards/vendor-dashboard">
                  {{ tr('Vendor Dashboard') }}
                </nuxt-link>
              </li>

              <li>
                <hr class="dropdown-divider" />
              </li>

              <li v-if="permission('sales')">
                <nuxt-link class="dropdown-item" to="/reporting/report-builder">
                  {{ tr('Report Builder') }}
                </nuxt-link>
              </li>

              <template v-if="role(['vendor'])">
                <li>
                  <nuxt-link class="dropdown-item" to="/reporting/member-list">
                    {{ tr('Store Listing') }}
                  </nuxt-link>
                </li>
                <li>
                  <nuxt-link class="dropdown-item" to="/resources/department-reference">
                    {{ tr('Department Listing') }}
                  </nuxt-link>
                </li>
              </template>

              <li v-if="permission('fulfillment') && permission('sales')">
                <nuxt-link class="dropdown-item" to="/fulfillment/analytics">
                  {{ tr('Web Fulfillment Analytics') }}
                </nuxt-link>
              </li>

              <template v-if="$userStore.special_reports">
                <li>
                  <hr class="dropdown-divider" />
                </li>
                <li
                  v-for="report in $userStore.special_reports"
                  :key="report.href"
                  class="custom-report"
                >
                  <a
                    v-if="report.href"
                    :href="report.href ? report.href : null"
                    class="dropdown-item"
                  >
                    <tooltip>{{ tr(report.description) }}</tooltip>
                    {{ report.title }}
                  </a>
                  <nuxt-link v-else :to="report.route ? report.route : null" class="dropdown-item">
                    <tooltip>{{ tr(report.description) }}</tooltip>
                    {{ report.title }}
                  </nuxt-link>
                </li>
              </template>
            </ul>
          </li>

          <li
            v-if="
              role(['buyer', 'member']) &&
              (permission('marketing') || permission('show data') || permission('fulfillment'))
            "
            class="nav-item dropdown"
          >
            <a class="nav-link dropdown-toggle" data-bs-toggle="dropdown" role="button">
              {{ tr(`Resources`) }}
            </a>
            <ul class="dropdown-menu">
              <li v-if="permission('show data')">
                <nuxt-link class="dropdown-item" to="/resources/department-reference">
                  {{ tr('Dept/Vendor Reference') }}
                </nuxt-link>
              </li>
              <li v-if="permission('marketing')">
                <nuxt-link class="dropdown-item" to="/resources/marketing-assets"
                  >{{ tr('Marketing Assets') }}
                </nuxt-link>
              </li>
              <li v-if="permission('marketing')">
                <nuxt-link class="dropdown-item" to="/resources/signage-generator"
                  >{{ tr('Signage Generator') }}
                </nuxt-link>
              </li>
              <li v-if="permission('show data')">
                <nuxt-link class="dropdown-item" to="/resources/pos-documentation">
                  {{ tr('POS Documentation') }}
                </nuxt-link>
              </li>
              <li v-if="permission('fulfillment')">
                <nuxt-link class="dropdown-item" to="/pages/website-member-sop">
                  {{ tr('Website Training and SOP') }}
                </nuxt-link>
              </li>
              <li v-if="permission('show data')">
                <nuxt-link class="dropdown-item" to="/resources/upcoming-price-changes">
                  {{ tr('Price Change Calendar') }}
                </nuxt-link>
              </li>
              <li v-if="permission('show data')">
                <nuxt-link class="dropdown-item" to="/resources/upc-validation">
                  {{ tr('UPC Validation') }}
                </nuxt-link>
              </li>
              <li>
                <nuxt-link class="dropdown-item" to="/scan-pal">
                  {{ tr('Inventory Scanner') }}
                </nuxt-link>
              </li>
              <li>
                <nuxt-link class="dropdown-item" to="/resources/label-printer">
                  {{ tr('Zebra Shipping Label Printing') }}
                </nuxt-link>
              </li>
              <li>
                <nuxt-link class="dropdown-item" to="/resources/store-training">
                  {{ tr('Staff Training') }}
                </nuxt-link>
              </li>
            </ul>
          </li>

          <li v-if="role(['buyer', 'member']) && permission('show data')" class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" data-bs-toggle="dropdown" role="button">
              {{ tr(`Program Data`) }}
            </a>
            <ul class="dropdown-menu">
              <li>
                <nuxt-link class="dropdown-item" to="/showcloud">
                  {{ tr('ShowCloud') }}
                </nuxt-link>
              </li>
              <li>
                <nuxt-link class="dropdown-item" to="/specials">
                  {{ tr('Warehouse + Specials') }}
                </nuxt-link>
              </li>
              <li>
                <nuxt-link class="dropdown-item" to="/show/files">
                  {{ tr('Programs/Files') }}
                </nuxt-link>
              </li>
              <li>
                <nuxt-link class="dropdown-item" to="/show/archives">
                  {{ tr('Past Shows') }}
                </nuxt-link>
              </li>
            </ul>
          </li>

          <li v-if="role(['buyer'])" class="nav-item">
            <nuxt-link class="nav-link" to="/fulfillment/admin">
              {{ tr('Fulfillment') }}
            </nuxt-link>
          </li>

          <li
            v-else-if="
              role(['member']) && (permission('fulfillment') || permission('team fulfillment'))
            "
            class="nav-item"
          >
            <nuxt-link class="nav-link" to="/fulfillment">
              {{ tr('Fulfillment') }}
            </nuxt-link>
          </li>

          <li v-if="$userStore.active_show" class="nav-item">
            <nuxt-link :to="`/show/${$userStore.active_show.key}`" class="nav-link">
              {{ tr($userStore.active_show.short_name) }}
            </nuxt-link>
          </li>
        </ul>

        <!-- Right nav -->
        <ul v-if="user && user.Verified && !empty" class="navbar-nav ms-auto">
          <li v-if="role(['buyer', 'member'])" class="nav-item">
            <nuxt-link class="nav-link" to="/support">
              {{ tr('Support') }}
            </nuxt-link>
          </li>

          <li v-if="role(['buyer'])" class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" data-bs-toggle="dropdown" role="button">
              {{ tr(`Head Office`) }}
            </a>
            <ul class="dropdown-menu dropdown-menu-end">
              <li>
                <nuxt-link class="dropdown-item" to="/marketing">
                  {{ tr('Marketing Information') }}
                </nuxt-link>
              </li>
              <li>
                <nuxt-link class="dropdown-item" to="/head-office">
                  {{ tr('Directory') }}
                </nuxt-link>
              </li>
              <li>
                <nuxt-link class="dropdown-item" to="/head-office/quote-parser">
                  {{ tr('Quote Parser') }}
                </nuxt-link>
              </li>
              <li>
                <nuxt-link class="dropdown-item" to="/head-office/store-master">
                  {{ tr('Store Master') }}
                </nuxt-link>
              </li>
              <li v-if="user.Site_Admin">
                <nuxt-link class="dropdown-item" to="/admin">
                  {{ tr('Admin') }}
                </nuxt-link>
              </li>
            </ul>
          </li>

          <li v-if="user.Stores.length > 1" class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" data-bs-toggle="dropdown" role="button">
              {{ user.Stores[0][1] }}
            </a>
            <ul class="dropdown-menu dropdown-menu-end">
              <li
                v-for="store in user.Stores.slice(1)"
                :key="`chg-` + store"
                class="dropdown-item"
                @click="change_store(store)"
              >
                {{ store[1] }}
              </li>
            </ul>
          </li>

          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" data-bs-toggle="dropdown" role="button">
              {{ $userStore.locale.substring(0, 2).toUpperCase() }}
            </a>
            <ul class="dropdown-menu dropdown-menu-end">
              <li class="dropdown-item cursor-pointer" @click="change_language('en-US')">EN</li>
              <li class="dropdown-item cursor-pointer" @click="change_language('fr-CA')">FR</li>
            </ul>
          </li>

          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" data-bs-toggle="dropdown" role="button">
              <account-circle-icon />
            </a>
            <ul class="dropdown-menu dropdown-menu-end">
              <li>
                <nuxt-link v-if="user.Verified" class="dropdown-item" to="/account">
                  {{ tr('Management') }}
                </nuxt-link>
              </li>
              <li class="dropdown-item cursor-pointer" @click="logout">
                {{ tr('Logout') }}
              </li>
            </ul>
          </li>
        </ul>
        <ul v-else-if="user && !user.Verified && !empty" class="navbar-nav ms-auto">
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" data-bs-toggle="dropdown" role="button">
              <account-circle-icon />
            </a>
            <ul class="dropdown-menu dropdown-menu-end">
              <li class="dropdown-item cursor-pointer" @click="logout">
                {{ tr('Logout') }}
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
  import { tr } from '~/assets/scripts/helpers'

  export default {
    name: 'TopNavBar',
    props: {
      empty: { type: Boolean, default: false },
    },
    computed: {
      user() {
        return this.$userStore.$state.user
      },
    },
    methods: {
      tr,
      role(roles) {
        return roles.includes(this.user.Role)
      },
      permission(perm) {
        return this.user.Permissions[perm]
      },
      logout() {
        $api('/api/account/logout', { method: 'POST' }).then((_) => {
          this.$router.push('/')
          this.$userStore.logout()
        })
      },
      change_store(target) {
        $api('/api/account/set-primary-store', {
          method: 'POST',
          body: {
            store_number: target[0],
          },
        }).then((resp) => {
          this.$userStore.setStoresAndPermissions(resp)
          location.reload()
        })
      },
      change_language(lang) {
        $api('/api/account/set-locale', { method: 'POST', body: { locale: lang } }).then((resp) => {
          this.$userStore.setLocale(resp.locale)
          this.$toast.info(
            tr('Language changed, you may need to reload the page for all changes to take effect'),
            { duration: 3000 },
          )
        })
      },
    },
  }
</script>

<style scoped></style>
